import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "GuideTemplate",
    title: "Guide Template",
    icon: require("plant-common/src/components/plant-item-viewer/guideTemplate/content-icon.svg"),
    Viewer,
    Editor
}